/* Safe motion only (v44): nothing here hides content, moves layout, or
   touches scrolling.
   1. Add to cart: light shine sweep + soft press.
   2. Cards lift slightly on hover (desktop mouse only). */
(function(){
if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var css=document.createElement('style');
css.textContent=
'#if-add,#ifs-btn{position:relative;overflow:hidden;transition:transform .15s ease,box-shadow .25s ease}'+
'#if-add:active,#ifs-btn:active{transform:scale(.97)}'+
'#if-add:after,#ifs-btn:after{content:"";position:absolute;top:0;left:-60%;width:40%;height:100%;background:linear-gradient(100deg,transparent,rgba(255,255,255,.45),transparent);transform:skewX(-18deg);animation:ifShine 4.2s ease-in-out infinite;pointer-events:none}'+
'@keyframes ifShine{0%,62%{left:-60%}100%{left:130%}}'+
'#if-add{box-shadow:0 10px 24px rgba(255,77,20,.28)}'+
'@media(hover:hover){#if-reviews > *,[data-if-face]{transition:transform .3s ease,box-shadow .3s ease}#if-reviews > *:hover,[data-if-face]:hover{transform:translateY(-3px);box-shadow:0 12px 26px rgba(18,22,28,.16)}}';
document.head.appendChild(css);
})();
